import type { IconProps } from "./icon-types";

/**
 * 상단 막대 + 위 화살표(arrow-up-to-line). "맨 위로 스크롤"/처음으로 이동 등에서 사용
 * (제품 의미 부여는 소비 앱의 semantic alias 책임). 짝은 `ArrowDownToLineIcon`.
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). AngleDouble* 과 같은 24 그리드 / stroke 기반.
 */
export const ArrowUpToLineIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M5 3h14" />
    <path d="M12 21V7" />
    <path d="m6 13 6-6 6 6" />
  </svg>
);
